import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import documentsEn from './locales/en/documents.json';
import legalEn from './locales/en/legal.json';
import legalLettersEn from './locales/en/legalLetters.json';
import glossaryEn from './locales/en/glossary.json';
import deadlineCalculatorEn from './locales/en/deadlineCalculator.json';
import smallClaimsEn from './locales/en/smallClaims.json';
import nameChangeEn from './locales/en/nameChange.json';
import tenantRightsEn from './locales/en/tenantRights.json';
import employmentEn from './locales/en/employment.json';
import contractNegotiationEn from './locales/en/contractNegotiation.json';
import aiAdvisorEn from './locales/en/aiAdvisor.json';
import feedbackEn from './locales/en/feedback.json';
import businessFormationEn from './locales/en/businessFormation.json';
import trademarkEn from './locales/en/trademark.json';
import businessContractsEn from './locales/en/businessContracts.json';

import commonEs from './locales/es/common.json';
import authEs from './locales/es/auth.json';
import documentsEs from './locales/es/documents.json';
import legalEs from './locales/es/legal.json';
import legalLettersEs from './locales/es/legalLetters.json';
import glossaryEs from './locales/es/glossary.json';
import deadlineCalculatorEs from './locales/es/deadlineCalculator.json';
import smallClaimsEs from './locales/es/smallClaims.json';
import nameChangeEs from './locales/es/nameChange.json';
import tenantRightsEs from './locales/es/tenantRights.json';
import employmentEs from './locales/es/employment.json';
import contractNegotiationEs from './locales/es/contractNegotiation.json';
import aiAdvisorEs from './locales/es/aiAdvisor.json';
import feedbackEs from './locales/es/feedback.json';
import businessFormationEs from './locales/es/businessFormation.json';
import trademarkEs from './locales/es/trademark.json';
import businessContractsEs from './locales/es/businessContracts.json';

import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import documentsFr from './locales/fr/documents.json';
import legalFr from './locales/fr/legal.json';
import legalLettersFr from './locales/fr/legalLetters.json';
import glossaryFr from './locales/fr/glossary.json';
import deadlineCalculatorFr from './locales/fr/deadlineCalculator.json';
import smallClaimsFr from './locales/fr/smallClaims.json';
import nameChangeFr from './locales/fr/nameChange.json';
import tenantRightsFr from './locales/fr/tenantRights.json';
import employmentFr from './locales/fr/employment.json';
import contractNegotiationFr from './locales/fr/contractNegotiation.json';
import aiAdvisorFr from './locales/fr/aiAdvisor.json';
import feedbackFr from './locales/fr/feedback.json';
import businessFormationFr from './locales/fr/businessFormation.json';
import trademarkFr from './locales/fr/trademark.json';
import businessContractsFr from './locales/fr/businessContracts.json';

import commonDe from './locales/de/common.json';
import authDe from './locales/de/auth.json';
import documentsDe from './locales/de/documents.json';
import legalDe from './locales/de/legal.json';
import legalLettersDe from './locales/de/legalLetters.json';
import glossaryDe from './locales/de/glossary.json';
import deadlineCalculatorDe from './locales/de/deadlineCalculator.json';
import smallClaimsDe from './locales/de/smallClaims.json';
import nameChangeDe from './locales/de/nameChange.json';
import tenantRightsDe from './locales/de/tenantRights.json';
import employmentDe from './locales/de/employment.json';
import contractNegotiationDe from './locales/de/contractNegotiation.json';
import aiAdvisorDe from './locales/de/aiAdvisor.json';
import feedbackDe from './locales/de/feedback.json';
import businessFormationDe from './locales/de/businessFormation.json';
import trademarkDe from './locales/de/trademark.json';
import businessContractsDe from './locales/de/businessContracts.json';

import commonIt from './locales/it/common.json';
import authIt from './locales/it/auth.json';
import documentsIt from './locales/it/documents.json';
import legalIt from './locales/it/legal.json';
import legalLettersIt from './locales/it/legalLetters.json';
import glossaryIt from './locales/it/glossary.json';
import deadlineCalculatorIt from './locales/it/deadlineCalculator.json';
import smallClaimsIt from './locales/it/smallClaims.json';
import nameChangeIt from './locales/it/nameChange.json';
import tenantRightsIt from './locales/it/tenantRights.json';
import employmentIt from './locales/it/employment.json';
import contractNegotiationIt from './locales/it/contractNegotiation.json';
import aiAdvisorIt from './locales/it/aiAdvisor.json';
import feedbackIt from './locales/it/feedback.json';
import businessFormationIt from './locales/it/businessFormation.json';
import trademarkIt from './locales/it/trademark.json';
import businessContractsIt from './locales/it/businessContracts.json';

// Translation resources
const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    documents: documentsEn,
    legal: legalEn,
    legalLetters: legalLettersEn,
    glossary: glossaryEn,
    deadlineCalculator: deadlineCalculatorEn,
    smallClaims: smallClaimsEn,
    nameChange: nameChangeEn,
    tenantRights: tenantRightsEn,
    employment: employmentEn,
    contractNegotiation: contractNegotiationEn,
    aiAdvisor: aiAdvisorEn,
    feedback: feedbackEn,
    businessFormation: businessFormationEn,
    trademark: trademarkEn,
    businessContracts: businessContractsEn,
  },
  es: {
    common: commonEs,
    auth: authEs,
    documents: documentsEs,
    legal: legalEs,
    legalLetters: legalLettersEs,
    glossary: glossaryEs,
    deadlineCalculator: deadlineCalculatorEs,
    smallClaims: smallClaimsEs,
    nameChange: nameChangeEs,
    tenantRights: tenantRightsEs,
    employment: employmentEs,
    contractNegotiation: contractNegotiationEs,
    aiAdvisor: aiAdvisorEs,
    feedback: feedbackEs,
    businessFormation: businessFormationEs,
    trademark: trademarkEs,
    businessContracts: businessContractsEs,
  },
  fr: {
    common: commonFr,
    auth: authFr,
    documents: documentsFr,
    legal: legalFr,
    legalLetters: legalLettersFr,
    glossary: glossaryFr,
    deadlineCalculator: deadlineCalculatorFr,
    smallClaims: smallClaimsFr,
    nameChange: nameChangeFr,
    tenantRights: tenantRightsFr,
    employment: employmentFr,
    contractNegotiation: contractNegotiationFr,
    aiAdvisor: aiAdvisorFr,
    feedback: feedbackFr,
    businessFormation: businessFormationFr,
    trademark: trademarkFr,
    businessContracts: businessContractsFr,
  },
  de: {
    common: commonDe,
    auth: authDe,
    documents: documentsDe,
    legal: legalDe,
    legalLetters: legalLettersDe,
    glossary: glossaryDe,
    deadlineCalculator: deadlineCalculatorDe,
    smallClaims: smallClaimsDe,
    nameChange: nameChangeDe,
    tenantRights: tenantRightsDe,
    employment: employmentDe,
    contractNegotiation: contractNegotiationDe,
    aiAdvisor: aiAdvisorDe,
    feedback: feedbackDe,
    businessFormation: businessFormationDe,
    trademark: trademarkDe,
    businessContracts: businessContractsDe,
  },
  it: {
    common: commonIt,
    auth: authIt,
    documents: documentsIt,
    legal: legalIt,
    legalLetters: legalLettersIt,
    glossary: glossaryIt,
    deadlineCalculator: deadlineCalculatorIt,
    smallClaims: smallClaimsIt,
    nameChange: nameChangeIt,
    tenantRights: tenantRightsIt,
    employment: employmentIt,
    contractNegotiation: contractNegotiationIt,
    aiAdvisor: aiAdvisorIt,
    feedback: feedbackIt,
    businessFormation: businessFormationIt,
    trademark: trademarkIt,
    businessContracts: businessContractsIt,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'documents', 'legal', 'legalLetters', 'glossary', 'deadlineCalculator', 'smallClaims', 'nameChange', 'tenantRights', 'employment', 'contractNegotiation', 'aiAdvisor', 'feedback', 'businessFormation', 'trademark', 'businessContracts'],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
